export const initialState = () => ({
  patientId: '',
});

export default initialState();
